import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/system";
import Typography from "@mui/material/Typography";
import PhoneIcon from "@mui/icons-material/Phone";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import InlineIconButton from "../InlineIconButton/InlineIconButton";
import StyledTooltip from "../../StyledTooltip/StyledTooltip";
import { formatPhoneNumber } from "../../../utils/formatHelpers";

export default function DialButton({ number, icon, typography, disabled, color }) {
  const formattedNumber = formatPhoneNumber(number);
  const hrefString = `tel:${formattedNumber}`;

  const getIcon = () => {
    if (icon === "phone") {
      return PhoneIcon; 
    } else if (icon === "mobile") {
      return PhoneIphoneIcon ;
    }
  };

  return (
    <a style={{ textDecoration: "none", ...(disabled && {pointerEvents: "none"}) }} href={hrefString}>
      {icon ? (
        <StyledTooltip title={number ? formattedNumber : ""}>
          <Box>
            <InlineIconButton 
              disabled={disabled}
              icon={getIcon()}
              buttonColor={color}
            />
          </Box>
        </StyledTooltip>
      ) : (
        <Typography  variant={typography} color="primary.60">
          {formattedNumber}
        </Typography>
      )}
    </a>
  );
}

DialButton.propTypes = {
  number: PropTypes.string,
  icon: PropTypes.string,
  typography: PropTypes.string,
  disabled: PropTypes.bool,
  color: PropTypes.string
};